import { MapBounds } from '../components/MapView/components/GoogleMap/AuctionsNearMeGoogleMap';

export const defaultPageNumber = 1;

export const defaultHitsPerPage = 24;

/**
 * Page sizes offered by the results pagination. Shared with the loader so a `?pageSize=` that
 * never came from the picker (a crawler, a hand-edited URL) cannot ask the backend for an
 * arbitrary page size.
 */
export const auctionsNearMePageSizeOptions = [24, 48, 72, 96, 120];

export const defaultAuctionsNearMeUsaBounds: MapBounds = {
    northEast: {
        lat: 46.4,
        lng: -64.3,
    },
    southWest: {
        lat: 28.7,
        lng: -123.4,
    },
};

export const defaultAuctionsNearMeUkBounds: MapBounds = {
    northEast: {
        lat: 59.147002,
        lng: 3.772578,
    },
    southWest: {
        lat: 49.686385,
        lng: -10.727177,
    },
};
